<template>
    <div class="d-flex flex-column align-items-center">
        
        <!-- Common main element parameters -->
        <div
            v-for="parameter in app.currentConfiguration.commonMainElementParameters"
            style="border: 0px solid black; background-color:white"
            :key="parameter.attribute.id"
            class="ml-2 mr-2 mb-4 mt-4"
        >
            <editParameterValueComponent
                ref="editParameterValueComponent"
                :labelOverInput="isMobile ? true : false"
                :parameter="parameter"
                :value.sync="parameter.value"
                @update:value="refreshParameters"
            ></editParameterValueComponent>
        </div>

        <!-- Iterate mainElements -->
        <div
            v-for="(mainElement,key,i) in app.currentConfiguration.mainElementParameters"
            class="d-flex flex-column"
            :key="i"
        >
            <div class="card mb-3">                
                <div class="card-header d-flex justify-content-between align-items-center pt-3">
                    <div></div>
                    <span class="font-weight-bold">{{mainElement['dimensiones'].attribute.name}}</span>
                    <button
                        @click.stop="cleanAllSelectors()"
                        style="font-weight:lighter; border-radius: 50%; height:40px; width:40px"
                        class="btn btn-outline-secondary ml-2"
                    >
                        <i class="fas fa-trash-alt"></i>
                    </button>
                </div>

                <div
                    class="card-body d-flex flex-column justify-content-between align-items-center flex-sm-row"
                >
                    <!-- imatge -->
                    <img
                        :style="'height: ' + imgSize + 'px; width: ' + imgSize + 'px;'"
                        class="mb-1"
                        :src="mainElement['dimensiones'].value ?
                                 mainElement['dimensiones'].value.image :
                                 mainElement['dimensiones'].values[0].image"
                        :ref="'div_imgs_numMoldura_' + key"
                    />

                    <div class="ml-3">
                        <editParameterValueComponent
                            ref="editParameterValueComponent"
                            :parameter="mainElement['dimensiones']"
                            :value.sync="mainElement['dimensiones'].value"
                            :labelOverInput="isMobile ? true : false"
                            :style_inside_dropdown="'width: ' + input_width + 'px'"
                            :prop_title_show="false"
                            @update:value="refreshParameters"
                        ></editParameterValueComponent>                       
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { app } from "../../application.js";
import { Fragment } from "vue-fragment";
import editParameterValueComponent from "./../editParameterValue.vue";

export default {
    name: "mainElements31Component",
    data() {
        return {
            app: app,
            confirmBeforeLeave: true,
            parameters: [],
            mainElementDistribution: "",
            labelOverDropdown: true,
            crossCompartimentosDimensiones: [],
            window: { width: 0, height: 0 },
        };
    },
    components: { editParameterValueComponent, Fragment },
    computed: {
        input_width: function(){
            return 170;
        },        
        isMobile: function() {
            let a = this.window.width < 760;
            return a;
        },
        imgSize: function() {
            if (this.isMobile) {
                return 200;
            }
            return 250;
        },
    },
    methods: {
        cleanAllSelectors: function () {
            //loop through mainElementParameters values resetting all selected values in currentConfiguration.mainElementParameters
            let mainparams = this.app.currentConfiguration
                .mainElementParameters;

            Object.values(mainparams).map((mainparam) => {
                Object.values(mainparam).map((item) => {
                    if (item.value.constructor.name == "Array") {
                        item.value = [];
                    } else {
                        item.value = "";
                    }
                });
            });

            this.refreshParameters();
        },
        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        },
        refreshParameters: async function () {
            await this.app.asyncProcess(false, false);
        },
    },
    created() {
        //get window size
        window.addEventListener("resize", this.handleResize);
        this.handleResize();
    },
    destroyed() {
        window.removeEventListener("resize", this.handleResize);
    },

    async beforeMount() {
        var self = this;
        app.showSpinner();

        this.refreshParameters();

        app.hideSpinner();
    },
};
</script>

<style lang="scss">
</style>
